/**
 * Public Signal Approval Receipt V1 - Edited Draft Scanner
 * 
 * Scans edited draft text for forbidden terms.
 * 
 * BOUNDARIES:
 * - Advisory only: no execution authority
 * - Deterministic output only
 * - Fail closed on forbidden patterns
 * - No mutation of inputs
 */

import { EditedDraftScanResult } from './types';
import { scanForbiddenTerms } from '../publicSignalDraft/forbiddenTermScanner';

/**
 * Scan edited draft text for forbidden terms
 */
export function scanEditedDraft(editedText: string): EditedDraftScanResult {
  const matches = scanForbiddenTerms(editedText);
  const forbiddenTerms = matches.map(m => m.matchedText);

  return {
    safe: forbiddenTerms.length === 0,
    forbiddenTerms,
  };
}
